<template>
  <!--订单详情-->
  <div class="order-detail">
    <a-form :form="form" labelAlign="left">
      <div class="card-box">
        <div class="card">
          <div class="card-body">
            <template v-if="orderData.fileType === 1">
              <div @click="mediaVisible = true" class="media-container">
                <img :style="{cursor: 'pointer'}" :src="orderData.mediaPath" alt="">
              </div>
            </template>
            <template v-else>
              <div @click="mediaVisible = true" class="media-container">
                <video :style="{cursor: 'pointer'}" :src="orderData.mediaPath" controls>
                  对不起，您的浏览器不支持该格式！
                </video>
              </div>
            </template>
          </div>
        </div>
        <div class="line-box">
          <p class="line"></p>
        </div>
        <div class="card">
          <div class="card-head status">
            <h3>
              {{orderData.orderStatus}}
              <span v-if="orderData.tag" :style="{fontSize: '20px'}">
                ({{orderData.tag}}
                <span v-if="orderData.refundContent">: {{orderData.refundContent}}</span>)
              </span>
            </h3>
          </div>
          <div class="card-body">
            <a-form-item v-for="(item, index) of baseInfo" :key="index" :label="item.label">
              <span class="ant-form-text">{{item.value}}</span>
            </a-form-item>
          </div>
        </div>
      </div>

      <div class="card-box" :style="{marginTop: '16px'}">
        <div class="card" :style="{marginRight: '16px'}">
          <div class="card-head">
            <h3>订单详情</h3>
          </div>
          <div class="card-body">
            <a-form-item v-for="(item, index) of orderInfo" :key="index" :label="item.label">
              <span class="ant-form-text">{{item.value}}</span>
            </a-form-item>

            <div style="border-top: 1px solid #e8e8e8" :style="{paddingTop: '10px'}">
              <a-form-item v-for="(item, index) of othersInfo" :key="index" :label="item.label" >
                <span class="ant-form-text">{{item.value}}</span>
              </a-form-item>
            </div>

          </div>
        </div>

        <div class="card">
          <div class="card-head">
            <h3>投放小区</h3>
            <span class="head-other">
              <span class="num">{{orderData.totalCommunity}}</span>个小区，<span class="num">{{orderData.totalDevs}}</span>台设备
            </span>
          </div>
          <div class="card-body">
            <x-tabula
              apiOrigin="PHP"
              ref="table"
              :dataSource="dataSource"
              rowKey="community_id"
              :columns="columns"
              :listApi="listApi"
              :rowSelection="false"
            >
            </x-tabula>
          </div>
        </div>
      </div>
    </a-form>

    <template v-if="toolbarShow">
      <x-toolbar :toolBarList="toolBarList">
        <span :style="{marginRight: '30px'}">
          注：审核通过去广告系统上传的时候，广告单标题直接复制此页面的
          <span class="danger">订单标题</span>
        </span>
      </x-toolbar>
    </template>

    <!--审核拒绝的弹窗-->
    <a-modal
      title="审核拒绝"
      :visible="visible"
      @ok="submitHandle"
      @cancel="visible=false"
      :confirmLoading="btnLoading.loading"
      v-bind="$store.state.modalConfig"
      width="600px"
    >
        <a-form :form="rejectForm">
            <a-form-item label="拒绝原因" v-bind="$store.state.modal_ItemLayout">
                <a-input v-decorator="['refuse_content', refuseContent]" placeholder="请输入拒绝原因"/>
            </a-form-item>
        </a-form>
    </a-modal>

    <!--查看图片或视频的弹窗-->
    <a-modal
      :bodyStyle="{padding: '10px'}"
      :visible="mediaVisible"
      @cancel="mediaVisible=false"
      v-bind="$store.state.modalDetailConfig"
      width="auto"
    >
      <!--媒体大小比例缩小1/2.8-->
      <div :style="mediaStyle">
        <template v-if="orderData.fileType === 1">
          <img :style="{height: '100%'}" :src="orderData.mediaPath" alt="">
        </template>

        <template v-else>
          <video :style="{height: '100%'}" :src="orderData.mediaPath" controls>
            对不起，您的浏览器不支持该格式！
          </video>
        </template>
      </div>
    </a-modal>

  </div>
</template>

<script>
export default {
  name: 'orderDetail',
  data () {
    return {
      mediaVisible: false,
      queryParam: {},
      visible: false,
      toolbarShow: false,
      btnLoading: { loading: false },
      refuseContent: {
        rules: [
          {required: true, message: '请输入拒绝原因'},
          {min: 1, max: 20, message: '拒绝原因不大于20个字'}
        ]
      },
      itemLayout: {
        labelCol: {span: 6},
        wrapperCol: {span: 18}
      },
      orderData: {
        fileType: 1,
        mediaPath: '',
        orderStatus: '',
        totalCommunity: '',
        totalDevs: '',
        screenType: 1
      },
      baseInfo: [
        { label: '实付金额', key: 'real_total_fee', value: '' },
        { label: '展位单价', key: 'unit_price', value: '' },
        { label: '订单原价', key: 'total_fee', value: '' },
        { label: '优惠', key: 'discount', value: '' }
      ],
      orderInfo: [
        { label: '手机号', key: 'mobile_phone', value: '' },
        { label: '订单号', key: 'order_id', value: '' },
        { label: '订单标题', key: 'title', value: '' },
        { label: '选择展位', key: 'screen_type_desc', value: '' },
        { label: '投放时间', key: 'start_time', value: '' }
      ],
      othersInfo: [],
      infoList: [
        { label: '下单时间', key: 'create_time', value: '' },
        { label: '付款时间', key: 'pay_time', value: '' },
        { label: '付款方式', key: 'pay_type_desc', value: '' },
        { label: '关闭时间', key: 'close_time', value: '' },
        { label: '退款时间', key: 'refund_time', value: '' },
        { label: '审核时间', key: 'check_time', value: '' }
      ],
      toolBarList: [
        {text: '审核通过', handle: this.passModal, type: 'primary', key: 'pass'},
        {text: '审核拒绝', handle: () => { this.visible = true; }, type: 'danger', key: 'reject'}
      ],

      /** table 参数 */
      dataSource: [],
      columns: [
        { title: '小区', dataIndex: 'community_name', align: 'left', width: '' },
        { title: '设备数', dataIndex: 'device_num', align: 'left', width: '' }
      ],
      listApi: {
        url: '',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      }
    };
  },
  computed: {
    mediaStyle () {
      return {
        height: this.orderData.screenType === 1 ? '385px' : '685px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      };
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this);
    this.rejectForm = this.$form.createForm(this);
  },
  created () {
    this.queryParam = this.$route.query;
    this.queryParam.type === 'nonAudit' && this.queryParam.status === '2' && (this.toolbarShow = true);
    this.handleInfoList();
    this.getDetail();
  },
  methods: {
    /** 处理不同订单阶段的信息列表 */
    handleInfoList () {
      let infoListType = {
        nonpay: ['create_time'],
        nonAudit: ['create_time', 'pay_time', 'pay_type_desc'],
        pass: ['create_time', 'pay_time', 'pay_type_desc', 'check_time'],
        closed: ['create_time', 'close_time'],
        service: ['create_time', 'pay_time', 'pay_type_desc', 'refund_time', 'check_time']
      };
      let currentArr = infoListType[this.queryParam.type];
      let arr = [];
      this.infoList.forEach((el) => {
        if (currentArr.includes(el.key)) {
          arr.push(el);
        }
      });
      this.othersInfo = arr;

      if (this.queryParam.type === 'service') {
        let list = [
          {label: '退款金额', key: 'real_refund_fee', value: ''},
          {label: '退款单号', key: 'bill_refund_id', value: ''}
        ];
        this.baseInfo.splice(3, 1);
        this.baseInfo = this.baseInfo.concat(list);
      }
    },
    /** 获取订单详情 */
    getDetail () {
      let url;
      if (this.queryParam.type === 'service') {
        url = `/screen_show/refund_detail/${this.queryParam.id}`;
      } else {
        url = `/screen_show/order/${this.queryParam.id}`;
      }
      this._get({
        url: url,
        params: {}
      }).then(({data}) => {
        let tagObj = {
          pass: 'publish_status_desc',
          closed: 'close_type_desc',
          service: 'refund_status_desc'
        };
        let tag = tagObj[this.queryParam.type];
        let status = data.order_status_desc;

        this.orderData = {
          fileType: data.file_type,
          mediaPath: data.file_url,
          orderStatus: status,
          tag: tag ? data[tag] : undefined,
          refundContent: data.refund_fail_content,
          totalCommunity: data.total_community_num,
          totalDevs: data.total_device_num,
          screenType: data.screen_type
        };

        this.baseInfo.forEach((el, index) => {
          if (data.hasOwnProperty(el.key)) {
            if (el.label === '优惠') {
              if (data[el.key] === 10 || data[el.key] === '10.00') {
                this.baseInfo.splice(index, 1);
              } else {
                el.value = `${data[el.key]}折`;
              }
            } else if (el.label === '退款单号') {
              el.value = data[el.key];
            } else {
              el.value = `￥${data[el.key]}`;
            }
          }
        });

        this.orderInfo.forEach((el) => {
          if (data.hasOwnProperty(el.key)) {
            if (el.label === '投放时间') {
              el.value = `${data.start_time}—${data.expire_time}`;
            } else {
              el.value = data[el.key];
            }
          }
        });

        if (data.refund_type === 2) {
          this.othersInfo.push({
            label: '人工退款原因',
            key: 'refund_content',
            value: ''
          });
        } else if (data.refund_type === 1) {
          this.othersInfo.push({
            label: '审核不通过原因',
            key: 'refuse_content',
            value: ''
          });
        }

        this.othersInfo.forEach((el) => {
          if (data.hasOwnProperty(el.key)) {
            el.value = data[el.key];
          }
        });

        this.$refs.table.tableData = data.community_device_info;
      });
    },
    /** 通过审核弹窗 */
    passModal () {
      this.$confirm({
        content: '审核通过后需第一时间到广告后台投放广告，确定审核通过吗？',
        centered: true,
        onOk: (close) => {
          close();
          this.auditOrder(3);
        }
      });
    },
    /** 处理提交 */
    submitHandle () {
      this.rejectForm.validateFields((err, values) => {
        if (err) { return; }
        this.auditOrder(4, values);
      });
    },
    /** 审核订单 */
    auditOrder (status, values = {}) {
      let param = {};
      if (values.refuse_content) {
        param.refuse_content = values.refuse_content;
      }
      param.order_status = status;

      this._put({
        url: `/screen_show/check/${this.$route.query.id}`,
        params: {
          order_id: this.$route.query.id,
          ...param
        },
        btnLoading: this.btnLoading
      }).then(({data}) => {
        this.$store.commit('setOptData', true);
        this.visible = false;
        this.$message.success('审核成功');
        this.$router.go(-1);
      });
    }
  }
};
</script>

<style lang="scss">
@import "src/style/variable";
/** start 订单详情 */
.order-detail {
  .card-box {
    display: flex;
    .card {
      width: 50%;
      background-color: #fff;
      transition: all 0.2s;
      .card-head {
        display: flex;
        padding: 16px 0 16px 24px;
        border-bottom: 1px solid $gray_1;
        h3 {
          color: $black_2;
          font-weight: 600;
          font-size: 16px;
        }
        .head-other {
          margin-left: 44px;
          font-size: 14px;
          .num {
            color: $blue_1;
          }
        }
      }
      .status {
        border-bottom: none;
        h3 {
          color: $red_1;
          font-size: 36px;
          font-weight: 400;
        }
      }

      .card-body {
        padding: 24px;
        .ant-form-item {
          display: flex;
          margin-bottom: 10px;
        }
        .media-container {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          img,
          video {
            height: 270px;
            width: auto;
          }
        }
      }
    }

    .line-box {
      width: 1px;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      .line {
        height: 80%;
        border-right: 1px solid #e8e8e8;
      }
    }
  }
}
/** end 订单详情 */
</style>
